export default "__VITE_ASSET__06249c06__"